// /client/src/hooks/useAuth.js
import { useState, useEffect } from 'react';

const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const adminToken = localStorage.getItem('adminToken');
    setIsAuthenticated(!!adminToken); // True if adminToken exists
  }, []); // Runs on mount

  // Optional: Add a function to manually check auth state if needed
  // eslint-disable-next-line 
  const checkAuth = () => {
    const adminToken = localStorage.getItem('adminToken');
    setIsAuthenticated(!!adminToken);
    return !!adminToken;
  };

  return isAuthenticated; // Return the current auth state
};

export default useAuth;